import {AfterViewInit, Component} from '@angular/core';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['../../../styles/create-something.scss', '../../../styles/standard-elements.scss', './help.component.scss'],
    standalone: false
})
export class HelpComponent implements  AfterViewInit{

  scrolled = 0;
  maxScrolled = 0;

  titles = ['faqHelp', 'videosHelp', 'releaseHelp'];
  idNames = ['step1', 'step2', 'step3'];

  ngAfterViewInit() {
    this.maxScrolled = Math.max(this.maxScrolled, this.scrolled);
  }

  scroll(id: string) {
    const targetElement = document.getElementById(id);
    if (targetElement) {
      targetElement.scrollIntoView();
    }
    this.scrolled = this.idNames.indexOf(id);
  }

  onWindowScroll() {
    const sections = document.querySelectorAll('.form-outer-container');
    let currentSectionIndex = 0;

    sections.forEach((section, index) => {
      const rect = section.getBoundingClientRect();
      if (rect.top <= 200 && rect.bottom >= 200) {
        currentSectionIndex = index;
      }
    });

    this.scrolled = currentSectionIndex;
  }
}
